// Zona de negocio de la app (decisión D1 del spec G1), la misma del backend
// (SYSTEM_TIMEZONE). Es el ÚNICO lugar de la app que nombra una zona horaria. Todo
// instante se muestra en esta zona, también en el navegador: los días que valida el
// backend son días de Costa Rica. Grupo DiM Panamá (UTC-5) opera hoy con la hora de
// Costa Rica; si llega la zona por empresa, este resolutor la devuelve por empresa sin
// tocar a los consumidores.

const BUSINESS_TIME_ZONE = 'America/Costa_Rica';

/** Zona IANA de negocio. `companyId` queda para la zona por empresa (hoy no se usa). */
export function businessZone(_companyId?: string): string {
  return BUSINESS_TIME_ZONE;
}

export const MS_PER_DAY = 86_400 * 1000;
